module.exports = __webpack_public_path__ + "static/media/code.7373bcb2.png";